module.exports = __webpack_public_path__ + "img/PEUGEOT_3008.de416ff9.jpg";